// The cards in each age's civil and military decks, other than leaders and wonders (those: Constants/CardVersions.js), as
// [type, name, count]: a count for 2, 3 and 4 players ([2p, 3p, 4p]), or one number for any. Pacts are not used in a
// 2-player game.
//   BaseGame: the base game's decks (Through the Ages: A New Story of Civilization, card reference v1.09).
//   Expansion: what New Wonders and Leaders adds to them: new cards, and more copies of some (the count is how many more).
const { Age } = require("../Constants/Constants");
const { CardNames, CardTypes } = require("../Constants/Names/CardNames");

const Civil = CardTypes.CivilCardTypes;
const Mil = CardTypes.MilitaryCardTypes;
const T = CardNames.TechnologyNames;
const A = CardNames.ActionNames;
const E = CardNames.EventNames;
const Ter = CardNames.TerritoryNames;
const Ag = CardNames.AggressionNames;
const W = CardNames.WarNames;
const Tac = CardNames.TacticNames;
const P = CardNames.PactNames;

const BaseGame = {
    civil: {
        [Age.AgeA]: [
            [Civil.Action, A.CulturalHeritage, 1],
            [Civil.Action, A.EngineeringGenius, 1],
            [Civil.Action, A.Frugality, 2],
            [Civil.Action, A.Patriotism, 1],
            [Civil.Action, A.RichLand, 2],
            [Civil.Action, A.Stockpile, 1],
            [Civil.Action, A.UrbanGrowth, 2],
        ],
        [Age.Age1]: [
            [Civil.Technology, T.Production.Irrigation, 2],
            [Civil.Technology, T.Production.Iron, [2, 2, 3]],
            [Civil.Technology, T.Urban.Alchemy, [2, 2, 3]],
            [Civil.Technology, T.Urban.Theology, [1, 2, 2]],
            [Civil.Technology, T.Urban.BreadAndCircuses, [1, 2, 2]],
            [Civil.Technology, T.Urban.PrintingPress, 2],
            [Civil.Technology, T.Urban.Drama, [1, 2, 2]],
            [Civil.Technology, T.Military.Swordsmen, 2],
            [Civil.Technology, T.Military.Knights, [2, 2, 3]],
            [Civil.Technology, T.Government.Monarchy, [1, 2, 2]],
            [Civil.Technology, T.Government.Theocracy, 1],
            [Civil.Technology, T.Special.Warfare, [1, 2, 2]],
            [Civil.Technology, T.Special.CodeOfLaws, [1, 2, 2]],
            [Civil.Technology, T.Special.Cartography, 1],
            [Civil.Technology, T.Special.Masonry, 1],
            [Civil.Action, A.Breakthrough, 2],
            [Civil.Action, A.CulturalHeritage, 1],
            [Civil.Action, A.EngineeringGenius, 1],
            [Civil.Action, A.Frugality, 2],
            [Civil.Action, A.Patriotism, 1],
            [Civil.Action, A.Reserves, 2],
            [Civil.Action, A.RichLand, 2],
            [Civil.Action, A.UrbanGrowth, 2],
        ],
        [Age.Age2]: [
            [Civil.Technology, T.Production.SelectiveBreeding, [1, 2, 3]],
            [Civil.Technology, T.Production.Coal, [1, 2, 2]],
            [Civil.Technology, T.Urban.ScientificMethod, 2],
            [Civil.Technology, T.Urban.OrganizedReligion, 2],
            [Civil.Technology, T.Urban.TeamSports, 1],
            [Civil.Technology, T.Urban.Journalism, [1, 2, 2]],
            [Civil.Technology, T.Urban.Opera, 2],
            [Civil.Technology, T.Military.Riflemen, [1, 2, 2]],
            [Civil.Technology, T.Military.Cavalrymen, 2],
            [Civil.Technology, T.Military.Cannon, [2, 2, 3]],
            [Civil.Technology, T.Government.Republic, [1, 1, 2]],
            [Civil.Technology, T.Government.ConstitutionalMonarchy, [1, 2, 2]],
            [Civil.Technology, T.Special.Strategy, 1],
            [Civil.Technology, T.Special.JusticeSystem, 1],
            [Civil.Technology, T.Special.Navigation, 1],
            [Civil.Technology, T.Special.Architecture, [1, 2, 2]],
            [Civil.Action, A.Breakthrough, 2],
            [Civil.Action, A.EfficientUpgrade, 2],
            [Civil.Action, A.EngineeringGenius, 1],
            [Civil.Action, A.Frugality, 1],
            [Civil.Action, A.MilitaryBuildup, 1],
            [Civil.Action, A.Patriotism, 1],
            [Civil.Action, A.Reserves, 2],
            [Civil.Action, A.RevolutionaryIdea, 1],
            [Civil.Action, A.RichLand, 1],
            [Civil.Action, A.UrbanGrowth, 1],
        ],
        [Age.Age3]: [
            [Civil.Technology, T.Production.MechanizedAgriculture, [1, 2, 2]],
            [Civil.Technology, T.Production.Oil, [1, 2, 2]],
            [Civil.Technology, T.Urban.Computers, 2],
            [Civil.Technology, T.Urban.ProfessionalSports, [1, 1, 2]],
            [Civil.Technology, T.Urban.Multimedia, 2],
            [Civil.Technology, T.Urban.Movies, 2],
            [Civil.Technology, T.Military.ModernInfantry, [1, 2, 2]],
            [Civil.Technology, T.Military.Tanks, [1, 2, 2]],
            [Civil.Technology, T.Military.Rockets, [1, 2, 2]],
            [Civil.Technology, T.Military.AirForces, [2, 2, 3]],
            [Civil.Technology, T.Government.Communism, 1],
            [Civil.Technology, T.Government.Fundamentalism, 1],
            [Civil.Technology, T.Government.Democracy, [1, 2, 2]],
            [Civil.Technology, T.Special.MilitaryTheory, [1, 1, 2]],
            [Civil.Technology, T.Special.CivilService, 1],
            [Civil.Technology, T.Special.Satellites, 1],
            [Civil.Technology, T.Special.Engineering, 1],
            [Civil.Action, A.EfficientUpgrade, 2],
            [Civil.Action, A.EndowmentForTheArts, 1],
            [Civil.Action, A.EngineeringGenius, 1],
            [Civil.Action, A.MilitaryBuildup, 1],
            [Civil.Action, A.Patriotism, 1],
            [Civil.Action, A.Reserves, 3],
            [Civil.Action, A.RevolutionaryIdea, 2],
            [Civil.Action, A.UrbanGrowth, 2],
        ],
    },
    military: {
        [Age.AgeA]: [
            [Mil.Event, E.DevelopmentOfAgriculture, 1],
            [Mil.Event, E.DevelopmentOfCivilization, 1],
            [Mil.Event, E.DevelopmentOfCrafts, 1],
            [Mil.Event, E.DevelopmentOfMarkets, 1],
            [Mil.Event, E.DevelopmentOfPolitics, 1],
            [Mil.Event, E.DevelopmentOfReligion, 1],
            [Mil.Event, E.DevelopmentOfScience, 1],
            [Mil.Event, E.DevelopmentOfSettlement, 1],
            [Mil.Event, E.DevelopmentOfTradeRoutes, 1],
            [Mil.Event, E.DevelopmentOfWarfare, 1],
        ],
        [Age.Age1]: [
            [Mil.Event, E.Barbarians, 1],
            [Mil.Event, E.BorderConflict, 1],
            [Mil.Event, E.Crusades, 1],
            [Mil.Event, E.CulturalInfluence, 1],
            [Mil.Event, E.Foray, 1],
            [Mil.Event, E.GoodHarvest, 1],
            [Mil.Event, E.Immigration, 1],
            [Mil.Event, E.NewDeposits, 1],
            [Mil.Event, E.Pestilence, 1],
            [Mil.Event, E.Raiders, 1],
            [Mil.Event, E.Rats, 1],
            [Mil.Event, E.Rebellion, 1],
            [Mil.Event, E.ReignOfTerror, 1],
            [Mil.Event, E.ScientificBreakthrough, 1],
            [Mil.Event, E.UncertainBorders, 1],
            [Mil.Territory, Ter.DevelopedTerritory, 1],
            [Mil.Territory, Ter.HistoricTerritory, 1],
            [Mil.Territory, Ter.InhabitedTerritory, 1],
            [Mil.Territory, Ter.StrategicTerritory, 1],
            [Mil.Territory, Ter.VastTerritory, 1],
            [Mil.Territory, Ter.WealthyTerritory, 1],
            [Mil.Bonus, 'Bonus', 6],
            [Mil.Aggression, Ag.Enslave, 2],
            [Mil.Aggression, Ag.Plunder, 2],
            [Mil.Aggression, Ag.Raid, 2],
            [Mil.Tactic, Tac.FightingBand, 2],
            [Mil.Tactic, Tac.HeavyCavalry, 2],
            [Mil.Tactic, Tac.Legion, 2],
            [Mil.Tactic, Tac.MedievalArmy, 2],
            [Mil.Tactic, Tac.Phalanx, 2],
            [Mil.Pact, P.OpenBordersAgreement, [0, 1, 1]],
            [Mil.Pact, P.TradeRoutesAgreement, [0, 1, 1]],
        ],
        [Age.Age2]: [
            [Mil.Event, E.CivilUnrest, 1],
            [Mil.Event, E.ColdWar, 1],
            [Mil.Event, E.CrimeWave, 1],
            [Mil.Event, E.EconomicProgress, 1],
            [Mil.Event, E.Emigration, 1],
            [Mil.Event, E.Iconoclasm, 1],
            [Mil.Event, E.IndependenceDeclaration, 1],
            [Mil.Event, E.InternationalAgreement, 1],
            [Mil.Event, E.NationalPride, 1],
            [Mil.Event, E.PoliticsOfStrength, 1],
            [Mil.Event, E.PopularizationOfScience, 1],
            [Mil.Event, E.Prosperity, 1],
            [Mil.Event, E.RavagesOfTime, 1],
            [Mil.Event, E.Refugees, 1],
            [Mil.Event, E.Terrorism, 1],
            [Mil.Territory, Ter.DevelopedTerritory, 1],
            [Mil.Territory, Ter.HistoricTerritory, 1],
            [Mil.Territory, Ter.InhabitedTerritory, 1],
            [Mil.Territory, Ter.StrategicTerritory, 1],
            [Mil.Territory, Ter.VastTerritory, 1],
            [Mil.Territory, Ter.WealthyTerritory, 1],
            [Mil.Bonus, 'Bonus', 6],
            [Mil.Aggression, Ag.Annex, 1],
            [Mil.Aggression, Ag.Infiltrate, 2],
            [Mil.Aggression, Ag.Plunder, 2],
            [Mil.Aggression, Ag.Raid, 2],
            [Mil.Aggression, Ag.Spy, 2],
            [Mil.War, W.WarOverTechnology, 2],
            [Mil.War, W.WarOverTerritory, 2],
            [Mil.Tactic, Tac.ClassicArmy, 1],
            [Mil.Tactic, Tac.Conquistadors, 1],
            [Mil.Tactic, Tac.DefensiveArmy, 1],
            [Mil.Tactic, Tac.Fortifications, 1],
            [Mil.Tactic, Tac.MobileArtillery, 1],
            [Mil.Tactic, Tac.NapoleonicArmy, 1],
            [Mil.Pact, P.AcceptanceOfSupremacy, [0, 1, 1]],
            [Mil.Pact, P.InternationalTradeAgreement, [0, 1, 1]],
            [Mil.Pact, P.PromiseOfMilitaryProtection, [0, 1, 1]],
            [Mil.Pact, P.ScientificCooperation, [0, 1, 1]],
        ],
        [Age.Age3]: [
            [Mil.Event, E.ImpactOfAgriculture, 1],
            [Mil.Event, E.ImpactOfArchitecture, 1],
            [Mil.Event, E.ImpactOfBalance, 1],
            [Mil.Event, E.ImpactOfColonies, 1],
            [Mil.Event, E.ImpactOfCompetition, 1],
            [Mil.Event, E.ImpactOfGovernment, 1],
            [Mil.Event, E.ImpactOfHappiness, 1],
            [Mil.Event, E.ImpactOfIndustry, 1],
            [Mil.Event, E.ImpactOfPopulation, 1],
            [Mil.Event, E.ImpactOfProgress, 1],
            [Mil.Event, E.ImpactOfScience, 1],
            [Mil.Event, E.ImpactOfStrength, 1],
            [Mil.Event, E.ImpactOfTechnology, 1],
            [Mil.Event, E.ImpactOfVariety, 1],
            [Mil.Event, E.ImpactOfWonders, 1],
            [Mil.Bonus, 'Bonus', 6],
            [Mil.Aggression, Ag.ArmedIntervention, 4],
            [Mil.Aggression, Ag.Plunder, 2],
            [Mil.Aggression, Ag.Raid, 2],
            [Mil.War, W.WarOverCulture, 6],
            [Mil.Tactic, Tac.Entrenchments, 1],
            [Mil.Tactic, Tac.MechanizedArmy, 2],
            [Mil.Tactic, Tac.ModernArmy, 2],
            [Mil.Tactic, Tac.ShockTroops, 1],
            [Mil.Pact, P.InternationalTourism, [0, 1, 1]],
            [Mil.Pact, P.LossOfSovereignty, [0, 1, 1]],
            [Mil.Pact, P.MilitaryAlliance, [0, 1, 1]],
            [Mil.Pact, P.PeaceTreaty, [0, 1, 1]],
        ],
    },
};

const Expansion = {
    civil: {
        [Age.Age1]: [
            [Civil.Action, A.RichLand, [0, 1, 1]], // more copies
        ],
        [Age.Age2]: [
            [Civil.Technology, T.Government.Republic, [0, 1, 0]], // more copies
            [Civil.Action, A.Frugality, [0, 1, 1]], // more copies
            [Civil.Action, A.UrbanGrowth, [0, 1, 1]], // more copies
        ],
        [Age.Age3]: [
            [Civil.Technology, T.Urban.ProfessionalSports, [0, 1, 0]], // more copies
            [Civil.Technology, T.Special.MilitaryTheory, [0, 1, 0]], // more copies
            [Civil.Action, A.Patriotism, [0, 1, 1]], // more copies
            [Civil.Action, A.Reserves, [0, 1, 1]], // more copies
            [Civil.Action, A.RevolutionaryIdea, [0, 1, 1]], // more copies
        ],
    },
    military: {
        [Age.AgeA]: [
            [Mil.Event, E.DevelopmentOfPlanning, 1],
        ],
        [Age.Age1]: [
            [Mil.Bonus, 'Bonus', 1], // more copies
            [Mil.Event, E.CallToArms, 1],
            [Mil.Event, E.DarkAges, 1],
            [Mil.Event, E.KnowledgeOfTheAncients, 1],
            [Mil.Aggression, Ag.Kidnap, 1],
            [Mil.Pact, P.NavalTradeAgreement, [0, 1, 1]],
        ],
        [Age.Age2]: [
            [Mil.Bonus, 'Bonus', 1], // more copies
            [Mil.Event, E.ArmsIndustry, 1],
            [Mil.Event, E.FreedomOfMovement, 1],
            [Mil.Event, E.InternationalNegotiations, 1],
            [Mil.Territory, Ter.AutonomousTerritory, 1],
            [Mil.Tactic, Tac.Hussars, 1],
        ],
        [Age.Age3]: [
            [Mil.Bonus, 'Bonus', 1], // more copies
            [Mil.Event, E.ImpactOfCulture, 1],
            [Mil.Event, E.ImpactOfHarmony, 1],
            [Mil.Aggression, Ag.Occupy, 1],
            [Mil.War, W.HybridWar, 1],
            [Mil.Tactic, Tac.PositionalArmy, 1],
        ],
    },
};

module.exports = { BaseGame, Expansion };
